import DiscountImg from '../../assets/discount.jpg'
import SpecialOfferImg from '../../assets/special.jpg'
import PhoneTabImg from '../../assets/phones&tab.jpg'
import TelevisionImg from '../../assets/television.jpg'
import FashionImg from '../../assets/fashion.webp'
import RefridgeratorImg from '../../assets/refridgerator.jpg'
import SportsImg from '../../assets/sport.jpg'
import GroceryImg from '../../assets/grocery.jpg'
import ComputerImg from '../../assets/computer.webp'
import MobileAccImg from '../../assets/mobileacc.jpg'
import GeneratorImg from '../../assets/generator.jpg'
import HomeImg from '../../assets/home.webp'

const CatByPics = () => {

    return (
        <div className=" container py-4">
            <div className=" p-2 rounded-md bg-white shadow-md">
                <div className=" grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2">
                    {
                        catByPicsList.map((item, index) => (
                            <a href='#/' key={index} className=" aspect-square flex flex-col group cursor-pointer">
                                <div className=" w-full h-[80%] bg-black rounded-md overflow-hidden flex-1 border-2 border-slate-300">
                                    <img src={item.img} className=' w-full h-full object-cover group-hover:scale-105 transition' alt="" />
                                </div>
                                <div className=" py-1 px-3 text-center font-semibold">{item.title}</div>
                            </a>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default CatByPics

const catByPicsList = [
    { img: DiscountImg, title: "Discount Sale" },
    { img: SpecialOfferImg, title: "Special Offers" },
    { img: PhoneTabImg, title: "Phones & Tablets" },
    { img: TelevisionImg, title: "Televisions" },
    { img: FashionImg, title: "Fashion Deals" },
    { img: RefridgeratorImg, title: "Refridgerators" },
    { img: SportsImg, title: "Sports" },
    { img: GroceryImg, title: "Grocery Deals" },
    { img: ComputerImg, title: "Computing Deals" },
    { img: MobileAccImg, title: "Mobile Accessories" },
    { img: GeneratorImg, title: "Generators" },
    { img: HomeImg, title: "Home Essentials" }
]